export default __webpack_public_path__ + "static/media/orderIDicon.48c49102.svg";